// Utility helpers for formatting dates/times in the user's local timezone.
// Accepts an ISO date string (e.g. "2025-11-27T07:18:24.192Z") and returns
// a localized, human-readable string with AM/PM time.
export function formatLocalDateTime(isoString) {
  if (!isoString) return "";
  const d = new Date(isoString);
  if (Number.isNaN(d.getTime())) return isoString;

  // Use the runtime's locale (undefined) so it formats according to user's system settings.
  // Format: "Nov 27, 2025, 7:18 AM"
  return d.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
}

